<template>
  <div class="d-flex align-center clickable" v-if="$_hasRole('student')">
    <span @click.stop="toggle()">
      <v-label class="clickable mr-1">{{
        value ? "Erledigt" : "Pendent"
      }}</v-label>
    </span>
    <v-checkbox
      :value="value"
      @click.stop="toggle()"
      :disabled="loading"
    ></v-checkbox>
  </div>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "NoteStudentTodo",
  props: {
    noteId: 0,
  },
  data() {
    return {
      value: false,
      loading: false,
    };
  },
  watch: {
    value(newValue) {
      this.$emit("updated", newValue);
    },
  },
  methods: {
    async toggle() {
      this.loading = true;
      const data = await this.apiPost({
        resource: "register/notestudent",
        data: { note: this.noteId, action: this.value ? "delete" : "create" },
      });
      this.value = data.done;
      this.loading = false;
    },
    async fetchData() {
      if (!this.$_hasRole("student")) {
        return;
      }
      this.loading = true;
      const data = await this.apiList({
        resource: "register/notestudent",
        query: `note=${this.noteId}`,
      });

      this.value = data.done;

      this.loading = false;
    },
  },
  computed: {},
  created() {
    this.fetchData();
  },
});
</script>
